import { Store } from 'vuex';

import { logger } from '@app/logger';
import { addFederationRoutes } from '@app/router';
import { setFullScreen } from '@app/utils/classToggler';
import { AuthenticationSubscriptionService } from '@store/modules/data/authentication/services/authenticationSubscriptionService';
import { defaultLayout } from '@app/router/utils';
import { AddRoutes } from '@superbet-group/web.types';
import UserSelectionsContainer from '@modules/sportOffer/UserSelectionsContainer.vue';

import SdsSportsSidebar from '@src/app/shared/modules/sportOffer/SdsSportsSidebar.vue';
import SdsProfileSidebar from '@src/app/modules/userProfile/SdsProfileSidebar.vue';

import SocialMobileHeader from '@app/mobile/navbar/SocialMobileHeader.vue';
import { SocialMobileSubnav } from '@src/app/mobile/subnavs';
import { isBelgiumGamingSite } from './helpers';

export async function initializeSocial(store: Store<unknown>): Promise<void> {
    try {
        const socialModule = await import('social/initializeFederation');
        await socialModule.initializeFederation({
            store,
            addRoutes: configureSocialLayoutRoutes,
            setFullScreen: setFullScreen,
            authentication: {
                registerPostLoginHandler: AuthenticationSubscriptionService.registerPostLoginHandler,
                registerPostLogoutHandler: AuthenticationSubscriptionService.registerPostLogoutHandler,
            },
            featureFlags: null,
            addMobileRouteActionItems: (routeActionItems) => {
                store.dispatch('navigation/addMobileRouteActionItems', routeActionItems);
            },
        });
    } catch (error) {
        logger.error(error as Error);
    }
}

const configureSocialLayoutRoutes: AddRoutes = (routes) => {
    addFederationRoutes(routes, isBelgiumGamingSite() ? {
        ...defaultLayout,
        leftSidebar: SdsProfileSidebar,
        mobileBottomContent: UserSelectionsContainer,
        mobileSubnav: SocialMobileSubnav,
        mobileHeader: SocialMobileHeader,
    } : {
        ...defaultLayout,
        leftSidebar: SdsSportsSidebar,
        rightSidebar: UserSelectionsContainer,
        mobileBottomContent: UserSelectionsContainer,
        mobileSubnav: SocialMobileSubnav,
        mobileHeader: SocialMobileHeader,
    });
};
